import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@material-ui/core"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"
import AppContext from "contexts/App"
import { useContext, useState } from "react"

import AccountDetailsForm from "./AccountDetailsForm"
import PasswordResetForm from "./PasswordResetForm"
import useStyles from "./styles"

const ClerkMyAccount = () => {
  const classes = useStyles()

  const { dialogs, closeDialog } = useContext(AppContext)
  const thisDialog = dialogs?.["clerkMyAccount"] || {}
  const { open = false, data = {} } = thisDialog

  const handleClose = () => {
    closeDialog("clerkMyAccount")
  }

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleClose()
        }
      }}
      classes={{ paperWidthSm: classes.paper }}
      disableBackdropClick
    >
      <DialogTitle className={classes.titleContainer} disableTypography>
        <Box display="flex" flexDirection="column">
          <Typography variant="h2">My Account</Typography>
          <Typography className={classes.subtitle}>
            Edit Information Here
          </Typography>
        </Box>
        <IconButton size="medium" variant="outlined" onClick={handleClose}>
          <HighlightOffIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <AccountDetailsForm />
        <Divider />
        <PasswordResetForm />
      </DialogContent>
    </Dialog>
  )
}

export default ClerkMyAccount
